import dynamic from 'next/dynamic';

const DynamicCompetitionForm = dynamic(
  () => import('../forms/competition-form'),
);

export const CompentitionSlice = () => <DynamicCompetitionForm />;
